import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, Facebook, Instagram } from "lucide-react";
import Logo from "./Logo";
import { BRAND, NAV_LINKS } from "../lib/brand";

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-[#1a1a1a]" data-testid="footer">
      <div className="container-kame py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Logo />
          <div className="mt-6 space-y-3 text-sm text-white/70">
            <p className="flex items-start gap-3">
              <MapPin size={18} className="text-[#B58A50] mt-0.5 shrink-0" />
              <span>
                {BRAND.address.street}
                <br />
                {BRAND.address.city}
                <br />
                {BRAND.address.part}
              </span>
            </p>
            <p className="flex items-center gap-3">
              <Mail size={18} className="text-[#B58A50] shrink-0" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-[#B58A50]">{BRAND.email}</a>
            </p>
            <p className="flex items-center gap-3">
              <Globe size={18} className="text-[#B58A50] shrink-0" />
              {BRAND.web}
            </p>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg text-white uppercase mb-5 tracking-wide">Kontakt</h4>
          <ul className="space-y-2 text-sm text-white/70">
            {BRAND.phones.map((p) => (
              <li key={p} className="flex items-center gap-3">
                <Phone size={16} className="text-[#B58A50] shrink-0" />
                <a href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-[#B58A50]">{p}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg text-white uppercase mb-5 tracking-wide">Rychlé odkazy</h4>
          <ul className="space-y-2 text-sm text-white/70">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[#B58A50]">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg text-white uppercase mb-5 tracking-wide">Informace</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/obchodni-podminky" className="hover:text-[#B58A50]">Obchodní podmínky</Link></li>
            <li><Link to="/gdpr" className="hover:text-[#B58A50]">GDPR</Link></li>
            <li><Link to="/cookies" className="hover:text-[#B58A50]">Cookies</Link></li>
            <li><Link to="/gdpr" className="hover:text-[#B58A50]">Ochrana osobních údajů</Link></li>
          </ul>
          <div className="mt-6">
            <p className="eyebrow mb-3">Sleduj nás</p>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/share/1CM4cT9MQV/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center border border-[#B58A50] rounded-full text-[#B58A50] hover:bg-[#B58A50] hover:text-black transition-colors duration-200"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://instagram.com/kameautopujcovna"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center border border-[#B58A50] rounded-full text-[#B58A50] hover:bg-[#B58A50] hover:text-black transition-colors duration-200"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-[#1a1a1a]">
        <div className="container-kame py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
          <p>© 2026 KAME Autopůjčovna. Všechna práva vyhrazena.</p>
          <p className="flex items-center gap-2">
            <span>
              Web vytvořil{" "}
              <a href="https://www.4uweb.cz" target="_blank" rel="noopener noreferrer" className="text-[#B58A50] hover:underline" data-testid="footer-4uweb-link">
                4uweb
              </a>
            </span>
            <span className="text-white/20">|</span>
            <Link to="/admin" className="hover:text-[#B58A50] transition-colors" data-testid="footer-admin-link">
              Administrace
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
